<div class="grid grid-cols-1 md:grid-cols-2 gap-20">
  <!--  Auth methods-->
  <div class="flex flex-col gap-4">
    <h1 class="authMenuTitle">Logowanie do PIU Emp&#64;tia</h1>
    <div class="flex flex-col gap-4 tiles-container">
      @for (authMethod of AUTH_METHODS_MENU_ITEM; track authMethod) {
        <button
          (click)="authMethod.action!()"
          (keyup.enter)="authMethod.action!()"
        >
          <div class="flex items-center tile tile-login">
            <i [ngClass]="['tile-icon', authMethod.icon]"></i>
            <div class="flex-1">
              <div class="tile-title">{{ authMethod.title }}</div>
              <div class="tile-description">
                {{ authMethod.label }}
              </div>
            </div>
            <i class="pi pi-angle-right tile-arrow"></i>
          </div>
        </button>
      }
    </div>
    <app-auth-tech-requirements-and-manual />
  </div>
  <app-info-section />
</div>
